var Colors;
(function (Colors) {
    Colors["black"] = "#000000";
    Colors["white"] = "#ffffff";
    Colors["gold50"] = "#FAF9F6";
    Colors["gold100"] = "#F1ECE3";
    Colors["gold150"] = "#E8DFD1";
    Colors["gold200"] = "#DED2BE";
    Colors["gold300"] = "#CBB899";
    Colors["gold400"] = "#B89E74";
    Colors["gold500"] = "#A28352";
    Colors["gold550"] = "#907140";
    Colors["gold600"] = "#79623D";
    Colors["gold700"] = "#514129";
    Colors["gold750"] = "#3C311F";
    Colors["gold800"] = "#282014";
    Colors["gray50"] = "#FAFAFA";
    Colors["gray100"] = "#EBEAE9";
    Colors["gray200"] = "#CCCAC8";
    Colors["gray400"] = "#999794";
    Colors["gray600"] = "#666563";
    Colors["gray700"] = "#4A4948";
    Colors["gray800"] = "#3B3B3B";
    Colors["gray900"] = "#242424";
    Colors["error100"] = "#FADBDB";
    Colors["error400"] = "#DF2020";
    Colors["error700"] = "#811212";
    Colors["success100"] = "#EBF1E4";
    Colors["success400"] = "#7EA859";
    Colors["success700"] = "#486133";
    Colors["warning100"] = "#FDEED8";
    Colors["warning400"] = "#F39E1F";
    Colors["warning700"] = "#8C5708";
})(Colors || (Colors = {}));
export default Colors;
//# sourceMappingURL=Colors.js.map